import React from 'react';
import { Scissors, Instagram, Facebook, MessageCircle, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About Us', id: 'about' },
    { name: 'Services', id: 'services' },
    { name: 'Branches', id: 'branches' },
    { name: 'Gallery', id: 'gallery' },
    { name: 'Reviews', id: 'reviews' },
    { name: 'Contact', id: 'contact' }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-[#C9A227]/20 blur-lg scale-110"></div>
                <img 
                  src="/marks-barber-logo-transparent.png" 
                  alt="Mark's Barber"
                  className="relative h-14 w-14 object-contain"
                  style={{
                    filter: 'drop-shadow(0 0 8px rgba(201, 162, 39, 0.5))'
                  }}
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white font-playfair tracking-wider">MARK'S BARBER</h3>
                <p className="text-xs text-[#C9A227] tracking-widest">EST. 2017</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Malaysia's premier destination for discerning gentlemen who demand excellence in grooming.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://wa.me/60380700000"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#C9A227] rounded-lg flex items-center justify-center transition-colors duration-300 group"
              >
                <MessageCircle className="w-5 h-5 text-white group-hover:text-black" />
              </a>
              <a
                href="https://instagram.com/marksbarber"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#C9A227] rounded-lg flex items-center justify-center transition-colors duration-300 group"
              >
                <Instagram className="w-5 h-5 text-white group-hover:text-black" />
              </a>
              <a
                href="https://facebook.com/marksbarber"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#C9A227] rounded-lg flex items-center justify-center transition-colors duration-300 group"
              >
                <Facebook className="w-5 h-5 text-white group-hover:text-black" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6 font-playfair">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-[#C9A227] transition-colors duration-300"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6 font-playfair">Services</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-[#C9A227] transition-colors duration-300 cursor-pointer">Classic Haircut</li>
              <li className="hover:text-[#C9A227] transition-colors duration-300 cursor-pointer">Skin Fade</li>
              <li className="hover:text-[#C9A227] transition-colors duration-300 cursor-pointer">Beard Styling</li>
              <li className="hover:text-[#C9A227] transition-colors duration-300 cursor-pointer">Hot Towel Shave</li>
              <li className="hover:text-[#C9A227] transition-colors duration-300 cursor-pointer">Hair Colour</li>
              <li className="hover:text-[#C9A227] transition-colors duration-300 cursor-pointer">Scalp Treatment</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6 font-playfair">Contact Us</h4>
            <div className="space-y-4">
              <div>
                <p className="text-sm text-gray-500 uppercase tracking-wide mb-1">Puchong Branch</p>
                <p className="text-gray-400">+60 3-8070 0000</p>
              </div>
              <div>
                <p className="text-sm text-gray-500 uppercase tracking-wide mb-1">Penang Branches</p>
                <p className="text-gray-400">+60 4-6410 0000</p>
              </div>
              <div>
                <p className="text-sm text-gray-500 uppercase tracking-wide mb-1">Email</p>
                <p className="text-gray-400">info@marksbarber.com</p>
              </div>
              <div>
                <p className="text-sm text-gray-500 uppercase tracking-wide mb-1">Hours</p>
                <p className="text-gray-400">10:00 AM - 10:00 PM Daily</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} Mark's Barber. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-500 hover:text-[#C9A227] transition-colors duration-300">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-[#C9A227] transition-colors duration-300">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;